import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {  Col, Input, Row, Label } from 'reactstrap';
import OSelect from '../../../Components/OElements/OSelect';
import AddEditWaterSourceModal from '../Config/WaterSource/Add_Edit/AddEditWaterSource';
import { DatePickerInput, DatesProvider } from '@mantine/dates';
import { getCommuneList, getRegionList, getCompanyList, getEstablishmenQuery } from '../../../helpers/establishment/backend_helper';
import { getWaterRightsStatusList as getWaterRightsStatusListApi } from '../../../helpers/water_rights_status/api_helper';
import { getWaterSourceList as getWaterSourceListApi } from '../../../helpers/water_source/api_helper';
import { useDispatch } from 'react-redux';
import {
    getWaterRightsStatusList,
    getWaterRightTypeList,
    getWaterSourceTypeList,
    getWaterUseTypeList,
    getWaterUseStatusList,
    getInstallationLocationList,
    getWaterSourceList
} from '../../../slices/thunks';


const GeneralTab = ({
    dataBeachCleaning,
    validation,
    handleSector
}) => {
    const dispatch = useDispatch();
    const [isDoneSelect, setIsDoneSelect] = useState(null);
    const [waterSourceModal, setWaterSourceModal] = useState(false);
    const [waterSourceRefetchKey, setWaterSourceRefetchKey] = useState(0);

    useEffect(() => {
        // Cargar todos los maestros al montar el componente
        dispatch(getWaterRightsStatusList());
        dispatch(getWaterRightTypeList());
        dispatch(getWaterSourceTypeList());
        dispatch(getWaterUseTypeList());
        dispatch(getWaterUseStatusList());
        dispatch(getInstallationLocationList());
        dispatch(getWaterSourceList());
    }, [dispatch]);

    return (
        <React.Fragment>
                <div>
                    <h5>Datos Generales</h5>
                    <p className="text-muted">Ingresa y selecciona los datos para el registro de derechos de agua</p>
                </div>
                
                <div>
                    <Row className='gx-2'>
                    <Col>
                        <Col className='mb-3'>
                            <OSelect
                                key="establishment_id"
                                label='Unidad de Cultivo'
                                id='establishment_id'
                                name='establishment_id'
                                value={validation.values.establishment_id || ''}
                                requestApi={() => getEstablishmenQuery({ filters: { disable: { $eq: false } }, pagination: { page: 1, pageSize: 999 }, fields: ['_id', 'name', 'region_id', 'commune_id', 'company_id'] }).then(res => res.data)}
                                validation={validation}
                                isRequired={true}
                                onSelect={(item) => {
                                    if (item) {
                                        validation.setFieldValue('region_id', item.region_id || '');
                                        validation.setFieldValue('commune_id', item.commune_id || '');
                                        validation.setFieldValue('company_id', item.company_id || '');
                                    }
                                }}
                            />
                        </Col>
                        <Col className='mb-3'>
                            <OSelect
                                key="region_id"
                                label="Región"
                                id="region_id"
                                name="region_id"
                                isRequired={true}
                                value={validation.values.region_id || ''}
                                requestApi={() => getRegionList({})}
                                disabled={false}
                                validation={validation}
                            />
                            
                        </Col>
                        <Col className='mb-3'>
                            <OSelect
                                key={`commune_id_${validation.values.region_id}`}
                                label="Comuna"
                                id="commune_id"
                                name="commune_id"
                                isRequired={true}
                                value={validation.values.commune_id || ''}
                                requestApi={() => getCommuneList({ region_id: validation.values.region_id })}
                                disabled={!validation.values.region_id} 
                                validation={validation}
                            />
                        </Col>
                        <Col className='mb-3'>
                            <Label for='resolution_number' className='form-label'>
                                N° Resolución DAA <span className='text-danger'>*</span>
                            </Label>
                            <Input
                                name='resolution_number'
                                id='resolution_number'
                                className='form-control'
                                placeholder='Ingrese el N° de Resolución DAA'
                                type='text'
                                value={validation.values.resolution_number || ''}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={validation.touched.resolution_number && validation.errors.resolution_number}
                            />
                            {validation.touched.resolution_number && validation.errors.resolution_number && (
                                <div className='invalid-feedback'>{validation.errors.resolution_number}</div>
                            )}
                        </Col>  
                        <Col className='mb-3'>
                            <OSelect
                                key="water_rights_status_id"
                                label="Estado De DAA"
                                id="water_rights_status_id"
                                name="water_rights_status_id"
                                value={validation.values.water_rights_status_id || ''}
                                requestApi={() => getWaterRightsStatusListApi().then(res => Array.isArray(res) ? res : (res?.data || []))}
                                validation={validation}
                                isRequired={true}
                            />
                        </Col>
                        <Col className='mb-3'>
                            <OSelect
                                key="water_source_type_id"
                                label="Clasificación Por La Naturaleza Del Agua"
                                id="water_source_type_id"
                                name="water_source_type_id"
                                value={validation.values.water_source_type_id || ''}
                                requestApi={() => dispatch(getWaterSourceTypeList()).then(res => res.payload)}
                                validation={validation}
                                isRequired={true}
                            />
                        </Col>
                        <Col className='mb-3'>
                            <OSelect
                                key="water_use_type_id"
                                label="Uso Del Agua"
                                id="water_use_type_id"
                                name="water_use_type_id"
                                value={validation.values.water_use_type_id || ''}
                                requestApi={() => dispatch(getWaterUseTypeList()).then(res => res.payload)}
                                validation={validation}
                                isRequired={true}
                            />
                        </Col>                                                                                                                
                        <Col className='mb-3'>
                            <OSelect
                                key={`water_source_id_${validation.values.region_id}_${waterSourceRefetchKey}`}
                                label="Fuente"
                                id="water_source_id"
                                name="water_source_id"
                                value={validation.values.water_source_id || []}
                                requestApi={() => getWaterSourceListApi({ filters: { region_id: { $eq: validation.values.region_id }, disable: { $eq: false } } }).then(res => res.data || res)}
                                disabled={!validation.values.region_id}
                                validation={validation}
                                isRequired={true}
                                isMulti={true}
                            />
                            <div className='mt-2'>
                                <a
                                    href='#'
                                    className='text-primary d-flex align-items-center'
                                    onClick={(e) => { e.preventDefault(); setWaterSourceModal(true); }}
                                >
                                    <i className='ri-add-circle-line me-1'></i>
                                    Ingresar nueva fuente
                                </a>
                            </div>
                        </Col>                     
                    </Col>
                    <Col>
                        <Col className='mb-3'>
                            <Label for='file_number' className='form-label'>
                                Código de Expediente <span className='text-danger'>*</span>
                            </Label>
                            <Input
                                name='file_number'
                                id='file_number'
                                className='form-control'
                                placeholder='Ingrese el Código de Expediente'
                                type='text'
                                value={validation.values.file_number || ''}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={validation.touched.file_number && validation.errors.file_number}
                            />
                            {validation.touched.file_number && validation.errors.file_number && (
                                <div className='invalid-feedback'>{validation.errors.file_number}</div>
                            )}
                        </Col> 
                        <Col className='mb-3'>
                            <OSelect
                                key="company_id"
                                label='Empresa'
                                id='company_id'
                                name='company_id'
                                value={validation.values.company_id || ''}
                                requestApi={() => getCompanyList()}
                                validation={validation}
                                isRequired={true}
                            />
                        </Col>                                                                                                 
                        <Col className='mb-3'>
                            <DatesProvider settings={{ locale: 'es-mx', firstDayOfWeek: 1, weekendDays: [0], timezone: 'UTC' }}>
                                <DatePickerInput
                                    label={<>Fecha Resolución DAA <span className='text-danger'>*</span></>}
                                    id='resolution_date'
                                    name='resolution_date'
                                    placeholder="Seleccione una fecha"
                                    value={validation.values.resolution_date || null}
                                    onChange={(date) => {
                                        validation.setFieldValue("resolution_date", date);
                                    }}
                                    onBlur={validation.handleBlur}
                                    valueFormat='DD-MM-YYYY'
                                    maxDate={new Date()}
                                    error={
                                        validation.touched['resolution_date'] &&
                                            validation.errors['resolution_date']
                                            ? validation.errors['resolution_date'] : ''
                                    }
                                    clearable={true}
                                    withAsterisk
                                />
                            </DatesProvider>
                        </Col>
                        <Col className='mb-3'>
                            <OSelect
                                key="water_right_type_id"
                                label='Tipo Derecho'
                                id='water_right_type_id'
                                name='water_right_type_id'
                                value={validation.values.water_right_type_id || ''}
                                requestApi={() => dispatch(getWaterRightTypeList()).then(res => res.payload)}
                                validation={validation}
                                isRequired={true}
                            />
                        </Col>
                        <Col className='mb-3'>
                            <OSelect
                                key="installation_location_ids"
                                label='Ubicación Para Instalación Y Medición De Software Por D.S 53/2020'
                                id='installation_location_ids'
                                name='installation_location_ids'
                                value={validation.values.installation_location_ids || []}
                                requestApi={() => dispatch(getInstallationLocationList()).then(res => res.payload)}
                                validation={validation}
                                isRequired={true}
                                isMulti={true}
                            />
                        </Col>
                        <Col className='mb-3'>
                            <OSelect
                                key="water_use_status_id"
                                label='Estado De Uso'
                                id='water_use_status_id'
                                name='water_use_status_id'
                                value={validation.values.water_use_status_id || ''}
                                requestApi={() => dispatch(getWaterUseStatusList()).then(res => res.payload)}
                                validation={validation}
                                isRequired={true}
                            />
                        </Col>                              
                    </Col>
                    </Row>
                </div>
        <AddEditWaterSourceModal
                isOpen={waterSourceModal}
                isEdit={false}
                dataWaterSource={null}
                handleToggleModal={() => setWaterSourceModal(!waterSourceModal)}
                toggleRefetch={() => setWaterSourceRefetchKey(k => k + 1)}
            />
        </React.Fragment>
    )
}

export default GeneralTab;